import clsx from "clsx";
import { useState, type JSX } from "react";
import { MdOutlineReport } from "react-icons/md";
import { ModalBase, toast } from "shared-components";

import { ReportSettings } from "./ReportSettings";
import { SuccessFeedback } from "./SuccessFeedback";
import { createReport } from "@/api/report";
import { useAuthGuard } from "@/hooks/use-auth-guard";

interface Props {
  className?: string;
  disabled?: boolean;
  productId: string;
}

export interface ReportOption {
  id: number;
  label: string;
}

export const ProductReportModal = ({ className, disabled, productId }: Props): JSX.Element => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [showDetailsInMobile, setShowDetailsInMobile] = useState(false);
  const [selectedOption, selectOption] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useAuthGuard();

  const onClose = () => {
    selectOption(null);
    setDetails("");
    setIsReportModalOpen(false);
  };

  const onSubmit = () => {
    setLoading(true);

    createReport({
      productId,
      cause: selectedOption?.label!,
      description: details.trim(),
    }).then((res) => {
      if (res?.error) {
        toast.error(res.error.message);
        setLoading(false);
      } else {
        setLoading(false);
        onClose();
        setIsFeedbackModalOpen(true);
      }
    });
  };

  const openReportModal = () => {
    if (isAuthenticated(true)) {
      setIsReportModalOpen(true);
    }
  };

  return (
    <div className={clsx("flex w-full lg:justify-end", className)}>
      <button
        className="flex items-center gap-1 text-feedback-error"
        disabled={disabled}
        onClick={() => {
          openReportModal();
        }}
      >
        <MdOutlineReport size="1.5rem" />

        <span>Denunciar produto</span>
      </button>

      <ModalBase isOpen={isReportModalOpen} onClose={onClose} isOverlayCloseable={false} hasCloseButton>
        <ReportSettings
          showDetailsInMobile={showDetailsInMobile}
          setShowDetailsInMobile={setShowDetailsInMobile}
          selectedOption={selectedOption}
          selectOption={selectOption}
          details={details}
          setDetails={setDetails}
          loading={loading}
          onSubmit={onSubmit}
        />
      </ModalBase>

      <ModalBase
        isOpen={isFeedbackModalOpen}
        onClose={() => {
          setIsFeedbackModalOpen(false);
        }}
        isOverlayCloseable={false}
        hasCloseButton
      >
        <SuccessFeedback
          onClose={() => {
            setIsFeedbackModalOpen(false);
          }}
        />
      </ModalBase>
    </div>
  );
};
